import { createUseThemeHook } from 'legos/theme';

// Augment the global BulkLegoTheme interface to support our lego theme
declare module 'legos/theme' {
  interface BulkLegoTheme {
    toastNotification: ToastTheme;
  }
}

export interface ToastTheme {
  backgroundColor: string;
  textColor: string;
  buttonColor: string;
}

const [ToastThemeProvider, useToastTheme] = createUseThemeHook(
  'toastNotification',
  (global): ToastTheme => ({
    backgroundColor: global.neutral.color900,
    textColor: global.neutral.color50,
    buttonColor: global.positive.color500
  })
);

export { ToastThemeProvider, useToastTheme };
